import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { H3, Btn, Image } from "../../AbstractElements";
import { useNavigate } from "react-router-dom";
import imgg from "../../assets/images/logo/logo.png";

const PaymentFailContain = () => {
  const navigate = useNavigate();
  const linkToRegister = () => {
    navigate(`${process.env.PUBLIC_URL}/login`);
  };
  return (
    <Container fluid={true} className="p-0">
      <Row>
        <Col xl="12">
          <div className="login-card">
            <Card>
              <CardHeader>
                <div className="logo-wrapper">
                  <a href="#javascript">
                    <Image
                      attrImage={{
                        className: "img-fluid",
                        src: `${imgg}`,
                        alt: "",
                      }}
                    />
                  </a>
                </div>
              </CardHeader>
              <CardBody>
                <div className="login-header text-center">
                  <H3>Error While Registering. Please contact admin.</H3>
                  <br></br>
                  <Btn
                    attrBtn={{
                      color: "primary",
                      className: "btn-block",
                      onClick: () => linkToRegister(),
                    }}
                  >
                    Go To Login Page
                  </Btn>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default PaymentFailContain;
